<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <rect width="256" height="256" fill="none" />
    <path
      d="M31.66,175.76a6,6,0,0,1-7.42-7.42l8.53-29.87a72,72,0,1,1,28.76,28.76Z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="16"
    />
    <path
      d="M92.06,175.89a72.05,72.05,0,0,0,102.41,39.34l29.87,8.53a6,6,0,0,0,7.42-7.42l-8.53-29.87A72,72,0,0,0,163.94,80.11"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="16"
    />
  </svg>
</template>

<script>
export default {};
</script>
